import { all, call } from "redux-saga/effects";
import messageSagas from "./messages/messages.sagas";
import widgetSagas from "./widget/widget.sagas";

export default function* rootSaga() {
  yield all([call(widgetSagas), call(messageSagas)]);
}
